export const getters = {
  getSelectedTemplate: state => state.selectedTemplate,
  getActiveView: state => state.activeView,
  getActiveType: state => state.activeType,
  getTemplates: state => state.templates,
  getGlobalTemplates: state => state.globalTemplates,
  getGlobalCompanyPermission: state => state.globalCompanyPermission,
  getGlobalUserPermission: state => state.globalUserPermission,
  getEditorsTypes: state => state.editorsTypes,
  getTags: state => state.tags,
  getUsers: state => state.users,
  getTemplateSummary: state => state.template.summary,
  getTemplateHistory: state => state.template.history,
  getTemplateContent: state => state.gridSelectedTemplate.content,
  getGridSelectedTemplate: state => state.gridSelectedTemplate,
  getLocale: state => state.locale,
  getDateFormat: state => state.dateFormat,
  getTimeFormat: state => state.timeFormat,
  getExternalId: state => state.externalId,
  getAccount: state => state.account,
  getAccountId: state => state.accountId,
  getEGalleryUid: state => state.eGalleryUid,
  getAllAccounts: state => state.allAccounts,
  getAllowedAccounts: state => state.allowedAccounts,
  getAvailableAccounts: state => state.availableAccounts,
  getUserEmail: state => state.userEmail,
  getEinsightUri: state => state.einsightUri,
  getAppConfig: state => state.appConfig,
  getPaging: state => state.paging,
  getGlobalPaging: state => state.globalPaging,
  getLoadingStatus: state => {
    let loadingCounter = 0
    const list = state.loadingStatus
    const keys = Object.keys(list)
    for (const key in keys) {
      const name = keys[key]
      if (list[name]) loadingCounter++
    }
    return loadingCounter > 0
  },
  getLoadingStatusList: state => state.loadingStatus,
  getLoadingStatusItem: (state, getters) => (name) => {
    return (name in getters.getLoadingStatusList ? getters.getLoadingStatusList[name] : false)
  },
  getTemplateSelectedForPreview: state => state.templateSelectedForPreview,
  getTemplatePreviewContent: state => state.templatePreviewContent,
  getGridStateChangeData: state => state.gridStateChangeData,
  getTemplateBasicValidation: state => state.template.basicValidation,
  getTemplateValidationByType: (state, getters) => (type) => {
    return getters.getTemplateBasicValidation.filter(validation => validation.testId === type)
  },
  getValidationTemplateId: state => state.validationTemplateId,
  getGrapesJSConfig: state => state.grapesJSConfig,
  getGrapesJSInstance: state => state.grapesJSInstance,
  getTemplateOnEdition: state => state.templateOnEdition,
  getDynamicContent: state => state.dynamicContent,
  getDynamicContentTabSelected: state => state.dynamicContent.selectedTab,
  getTagsSections: state => state.dynamicContent.tagsSections,
  getPersonalizationTags: state => state.dynamicContent.personalizationTags,
  getAddOns: state => state.dynamicContent.addOns,
  getCustomLinks: state => state.dynamicContent.customLinks,
  getGlobalLinks: state => state.dynamicContent.globalLinks,
  getGlobalLinkOnEdition: state => state.dynamicContent.globalLinkOnEdition,
  getSystemLinks: state => state.dynamicContent.systemLinks,
  getTaggedLinks: state => state.dynamicContent.taggedLinks,
  getAllLinks: state => state.dynamicContent.allLinks,
  getEmailTesting: state => state.emailTesting,
  getEmailTestingList: state => state.emailTesting.emailList,
  getEmailTestingGroups: state => state.emailTesting.groups,
  getEmailTestingOnEdition: state => state.emailTesting.emailTestingOnEdition,
  getEmailTestingEditingModalIsOpen: state => state.emailTesting.editingModalIsOpen,
  getAccessSettings: state => state.accessSettings,
  getSavedGridEditorFilter: state => state.savedGridEditorFilter,
  getPrebuiltGridEditorFilter: state => state.prebuiltGridEditorFilter,
  getBeeFreeConfig: state => state.appConfig.beeFree
}
